module.exports = __webpack_public_path__ + "static/media/procurement-headline.3be1d5ec.png";